import axios from 'axios'
import API from './API.js'

export default class Edu_courses extends API {
  constructor() {
    super('edu_courses')
  }

  async GetContents(params) {
    const response = await axios.get('/getContents', { params })
    return response.data
  }

  async getContentsNow(params) {
    const response = await axios.get('/getContentsNow', { params })
    return response.data
  }
  //
  async getAssessments(params) {
    const response = await axios.get('/getAssessments', { params })
    return response.data
  }

  //edu-courses/edu-course-programs
  async EduCoursePrograms(params) {
    const response = await axios.get('/edu-courses/edu-course-programs', { params })
    return response.data
  }
  async EduCourseProgramsActiveSemester(params) {
    const response = await axios.get('/edu-courses/edu-course-programs-active-semester', { params })
    return response.data
  }
  async teacherCourses(params){
    try {
      const response = await axios.get('teacher_courses', {params})
      let { data } = response
      if (params) data = response.data.data
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }
  async GetAllCourses(){
    try {
      const response = await axios.get('get-all-courses')
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }
}
